/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  rebateCMSSearchResult: [],
  errorMessagesInRedux: [],
  planViewHistory: [],
  matDrugListFromStore: [],
  editedData: [],
  extraState: {
    fullScreenView: false,
    edit: false,
  },
  errorField: {
    errorMessages: [],
    isError: false,
    showRateErr: false,
  },
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_CMS_TABLE_DATA:
      return { ...state, rebateCMSSearchResult: action.rebateCMSSearchResult };
    case actionTypes.GET_CMS_TABLE_EDITED_DATA:
      return { ...state, editedData: action.editedData };
    case actionTypes.VIEW_HISTORY:
      return { ...state, planViewHistory: action.planViewHistory };
    case actionTypes.CMS_ERROR:
      return { ...state, errorField: action.errorField };
    case actionTypes.CMS_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.SET_MAT_DRUG_LIST:
      return { ...state, matDrugListFromStore: action.payload };
    case actionTypes.SET_MAT_DRUG_SUCCESS:
      return { ...state, successRes: action.successRes };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_CMS:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.RESET_MAT_DRUG_STORE:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
